import React from 'react';
import { Button, ConfigProvider, theme } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import './CameraScanButton.css';

export default function CameraScanButton({ open, disabled = false, onClick, className = '' }) {
  return <ConfigProvider theme={{ inherit: false, algorithm: theme.defaultAlgorithm, token: { colorPrimary: '#007800', colorInfo: '#007800', fontFamily: '"Noto Sans KR", sans-serif' } }}><Button className={`camera-scan-button ${className}`} icon={<CameraOutlined />} aria-pressed={open} disabled={disabled} onClick={onClick}>{open ? '카메라 닫기' : '카메라로 스캔'}</Button></ConfigProvider>;
}
